const VacateUnit = {

    "vacate_unit": "Vacate Unit",

    // FIELDS
    "zone": "Zone",
    "level": "Level",
    "premise": "Premise",
    "unit": "Unit",
    "user": "User",
    "end_date": "End Date",
    "checklist": "Checklist",
    "documents": "Documents",
    "doc_name": "Document Name",
    "file": "File",

    // TOAST
    "success_add": "Unit Vacat Successfully",
    "warn_select_premise": "Please select a premise first",

    // ERROR
    "error_zone": "Select Zone",
    "error_level": "Select Level",
    "error_premise": "Select Premise",
    "error_unit": "Select Unit",
    "error_user": "Select User",
    "error_end_date": "Select End Date",

}

export default VacateUnit;